export enum SearchType {
  Person = 'person',
  Vendor = 'vendor',
  Manufacturer = 'manufacturer',
  Gateway = 'gateway',
  Product = 'product',
  ProductDetail = 'product_detail',
}
